import React from 'react'
import {useSelector} from 'react-redux'
import {advantagesSelector} from '../selectors'

export default function Advantages() {
    const advantages = useSelector(advantagesSelector)

    return (
        <If condition={advantages.length}>
            <div className="advantages">
                <For each="advantage" index="i" of={advantages}>
                    <div
                        key={i}
                        className="col-xs-12 col-sm-4 advantages__item"
                    >
                        <div className="advantage">
                            <h2
                                dangerouslySetInnerHTML={{
                                    __html: advantage.head,
                                }}
                                className="advantage__title"
                            />
                            <div className="advantage__description">
                                {advantage.body}
                            </div>
                        </div>
                    </div>
                </For>
            </div>
        </If>
    )
}
